import Button from "components/Buttons/ThemeButton";
import styled from "styled-components";

export const Container = styled.div<{
	scale: number;
	$backgroundImage: string;
}>`
	width: 100%;
	padding: 0px;

	width: 21.43em;
	height: 29.06em;
	position: relative;
	display: flex;
	justify-content: center;
	//overflow: hidden;
	border-radius: 18px;
	font-size: 1rem;
	transform: scale(${(props) => props.scale});
	//font-size: clamp(1px, 4dvw, 22px);
	//border: 4px solid #277aac;
	box-shadow: 0 0.32em 1em 0 rgba(0, 0, 0, 0.15);
	background-image: url(${(props) => props.$backgroundImage});
	background-size: cover;
	background-position: center;

	@media (orientation: landscape) {
		width: 56.87em;
		height: 25.69em;
	}
`;

export const OffersContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 0.4em;
	@media (orientation: landscape) {
		flex-direction: row;
		justify-content: center;
		align-items: center;
		gap: 1em;
	}
`;

export const Offer = styled.div`
	position: relative;
	width: 100%;
`;

export const OfferItem = styled.div`
	position: relative;
	z-index: 1;
	grid-template-rows: auto;
	background-color: rgba(0, 0, 0, 0.25);
	backdrop-filter: blur(14px);
	border-radius: 12px;
	padding: 0.6em 0.5em;
	gap: 0.5rem;
	box-sizing: border-box;
	height: 5.75em;
	//z-index: 999;
	align-content: stretch;
	width: 100%;

	@media (orientation: landscape) {
		padding: 1.4em 1em;
		height: 7.81em;
	}
`;

export const DataContainer = styled.div`
	position: absolute;
	width: 92%;
	bottom: 0.8em;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	@media (orientation: landscape) {
		bottom: 2em;
		width: 85%;
	}
`;

export const Items = styled.div`
	justify-content: center;
	align-items: end;
	display: flex;
	flex-wrap: nowrap;
`;

export const RewardItem = styled.div<{ width: string }>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-basis: ${(props) => props.width};
	box-sizing: border-box;
	gap: 0.2em;
`;

export const RewardAmountContainer = styled.div``;

export const ItemImage = styled.img`
	object-fit: contain;
	justify-self: center;
	align-self: center;

	width: 100%;
	height: 3.2em;

	@media (orientation: landscape) {
		height: 3.5em;
	}
`;

export const Text = styled.div`
	font-family: Baloo;
	-webkit-text-stroke-width: 0.15em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	color: #fff;
	filter: drop-shadow(0 0.049em 0 #000);
	font-style: normal;
	font-weight: 400;
`;

export const RewardAmount = styled(Text)`
	font-size: 1.3em;
	line-height: 1em;
`;

export const Title = styled(Text)`
	margin-top: 2em;
	font-size: 1.625em;
	line-height: 1em;
	font-weight: 400;
	width: 100%;
	padding: 0 1.5em;
	text-align: center;

	@media (orientation: landscape) {
		margin-top: 1.5em;
		font-size: 2.125em;
		padding: 0 3.6em;
	}
`;

export const SubTitle = styled(Text)`
	width: 100%;
	margin-left: 0.5em;
	font-size: 0.9375em;
	line-height: 1.4em;
	display: flex;
	align-items: start;
	-webkit-text-stroke-width: 0.2em;

	@media (orientation: landscape) {
		font-size: 1.21em;
	}
`;

export const CustomButton = styled(Button)`
	width: 100%;
	margin-top: 0.8em;
	height: 3.562em;
	font-size: 1em;
	text-transform: none;

	@media (orientation: landscape) {
		width: 20em;
		margin-top: 1.7em;
	}
`;
